const dateTimeFormats = {
  en: {
    rangeMonthFormat: { year: 'numeric', month: 'short' },
    rangeDateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
    weekDayFormat: { weekday: 'short', day: 'numeric' },
    dateFormat: { year: 'numeric', month: 'numeric', day: 'numeric' },
  },
  'en-US': {
    rangeMonthFormat: { year: 'numeric', month: 'short' },
    rangeDateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
    weekDayFormat: { weekday: 'short', day: 'numeric' },
    dateFormat: { year: 'numeric', month: 'numeric', day: 'numeric' },
  },
  de: {
    rangeMonthFormat: { year: 'numeric', month: 'short' },
    rangeDateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
    weekDayFormat: { weekday: 'short' },
    dateFormat: { year: 'numeric', month: 'numeric', day: 'numeric' },
  },
};

export default dateTimeFormats;
